import Service from '../../services'
import { baseUrl } from "../../services/Constants";
import Swal from "sweetalert2";
// initial state
const state = {
    // auth
    userData: [],
    userDetail: {},
    isLoggedIn: false,


    // user manager
    allAccountPaginate: {},
    accountForm: {
        first_name: '',
        last_name: '',
        email: '',
        username: '',
        password: '',
        c_password: ''
    }
};


// getters
const getters = {

};


// actions
const actions = {

    // auth
    onUserLogIn({ commit }, account) {
        Service.auth.onLogIn(account.email, account.password).then((res) => {
            if (res.status === 'success') {
                commit('setLoggedIn', res.result);
            }
        }).catch(() => {
            Swal.fire({
                icon: 'error',
                title: 'ผิดพลาด!',
                text: 'อีเมลชื่อผู้ใช้หรือพาสเวิร์ดไม่ถูกต้อง',
            })
           // alert('อีเมลชื่อผู้ใช้หรือพาสเวิร์ดไม่ถูกต้อง');
        });
    },

    onUserLoginWithGoogle({ commit }, data) {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('result')) {
            commit('setLoggedIn', data);
        } else {
            Swal.fire({
                icon: 'error',
                title: 'ผิดพลาด!',
                text: 'ไม่สามารถยืนยันตัวตนได้',
            })
            // alert('ไม่สามารถยืนยันตัวตนได้');
        }

    },

    onUserLogOut({ commit }, token) {
        return Service.auth.onLogOut(token).then(() => {

            // reload page after logged out
            window.location.reload();

            commit('setLogOut');

            // clear local storage
            window.localStorage.removeItem('vuex');

        });
    },

    onGetUserDetail({ commit }, data) {
        return Service.auth.getUserDetail(data).then((res) => {
            commit('setUserDetail', res);
        });
    },


    // User manager
    onGetAllAccountPaginate({ commit }, data) {
        return Service.auth.getAllAccountPaginate(data).then((res) => {
            commit('setAllAccountPaginate', res);
        });
    },

    onGetAccount({ commit }, data) {
        return Service.auth.getAccount(data).then((res) => {
            commit('setAccount', res);
        });
    },

    onCreateAccount({ commit }, data) {
        return Service.auth.createAccount(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'เพิ่มบัญชีผู้ใช้งานสำเร็จ',
            })
            // alert('เพิ่มบัญชีผู้ใช้งานสำเร็จ');
        });
    },

    onEditAccount({ commit }, data) {
        return Service.auth.editAccount(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'แก้ไขบัญชีผู้ใช้งานสำเร็จ',
            })
            // alert('แก้ไขบัญชีผู้ใช้งานสำเร็จ');
        });
    },

    onDeleteAccount({ commit }, data) {
        return Service.auth.deleteAccount(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'สำเร็จ!',
                text: 'ลบบัญชีผู้ใช้งานสำเร็จ',
            })
            // alert('ลบบัญชีผู้ใช้งานสำเร็จ');
        });
    }

};


// mutations
const mutations = {

    // auth
    setLoggedIn(state, data) {
        state.isLoggedIn = true;
        state.userData = data;
        window.location = baseUrl; // redirect to dashboard
    },

    setLogOut(state) {
        state.isLoggedIn = false;
        state.userData = [];
        state.userDetail = {};
    },

    setUserDetail(state, data) {
        state.userDetail = data;
    },


    // user manager
    setAllAccountPaginate(state, data) {
        state.allAccountPaginate = data;
    },

    setAccount(state, data) {
        state.accountForm = {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            username: data.username,
            password: data.password,
            c_password: ''
        };
    }


};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
